import {
  NO_DATA,
  CHECK_ICON,
  ONLINE,
  OFFLINE,
  CHECKED_ICON,
  LOADER_ICON,
  CLOSE_MODAL_ICON,
  CLOSE_MODAL_ICON_WHITE,
  CT_LOGO,
  BACK_ARROW,
  EDIT_PEN,
  REMOVE_ICON,
  WHITE_CHECK,
  SYNC,
  REMOVE_CIRCLE,
  INVALID_ICON,
} from 'assets/icons';

// Icons reachable from the offline flow (Assignments list, Survey, offline
// toasts/modals). Each import resolves to the hashed /static/media/ URL at
// runtime, which is exactly what the service worker caches. If an icon is
// added here and never rendered, the only cost is ~2-10KB of cache space.
const OFFLINE_CRITICAL_ICONS = [
  NO_DATA,
  CHECK_ICON,
  ONLINE,
  OFFLINE,
  CHECKED_ICON,
  LOADER_ICON,
  CLOSE_MODAL_ICON,
  CLOSE_MODAL_ICON_WHITE,
  CT_LOGO,
  BACK_ARROW,
  EDIT_PEN,
  REMOVE_ICON,
  WHITE_CHECK,
  SYNC,
  REMOVE_CIRCLE,
  INVALID_ICON,
];

const WARM_MESSAGE_TYPE = 'WARM_ASSETS';

// Post the list of critical icon URLs to the active service worker so it
// can ensure they're in the runtime caches that serve offline. The SW
// handler skips URLs that are already cached, so calling this repeatedly
// is cheap when the cache is warm and self-healing when it isn't.
const postWarmMessage = async () => {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker) return;
  try {
    const registration = await navigator.serviceWorker.ready;
    const target = registration.active || navigator.serviceWorker.controller;
    if (!target) return;
    const urls = OFFLINE_CRITICAL_ICONS.filter((url) => typeof url === 'string' && url.length > 0);
    if (urls.length === 0) return;
    target.postMessage({ type: WARM_MESSAGE_TYPE, urls });
  } catch (e) {
    // Best-effort — if the SW isn't reachable, the runtime caches still
    // populate naturally when the user renders the icons while online.
  }
};

let onlineListenerAttached = false;

// Fire the warm once on call, and also attach an `online` listener so a
// fast offline-after-boot (fetches failed during the initial warm) gets
// retried automatically when the user reconnects. Listener is attached
// once per page load; the idempotent SW-side guard ensures repeat runs
// skip already-cached entries.
const warmOfflineAssets = () => {
  postWarmMessage();
  if (typeof window !== 'undefined' && !onlineListenerAttached) {
    onlineListenerAttached = true;
    window.addEventListener('online', () => {
      postWarmMessage();
    });
  }
};

export default { warmOfflineAssets };
